import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import request from '../../../request';

export default class DeleteCompany extends React.Component {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  constructor() {
    super();
    this.state = {};
  }

  async delete() {
    let { location } = this.props;
    this.setState({ loading: true });

    try {
      await request({
        url: `admin/companies/${location.state.company.id}`,
        method: 'DELETE',
      });
      this.context.router.history.push('/settings/companies');
    } catch (error) {
      this.setState({ error: error.message, loading: false });
    }
  }

  render() {
    let { location } = this.props;
    let { loading, error } = this.state;

    return (
      <div id="edit" className="edge" style={{ opacity: loading ? 0.5 : 1 }}>
        <h5 className="heading">Delete "{location.state.company.name}"</h5>
        {error ? <p className="error">{error}</p> : null}
        <p>
          Are you sure you want to remove this company? You can't undo this.
        </p>
        <div id="dashboard">
          <div className="options">
            <button
              id="confirm"
              className="action primary"
              type="submit"
              onClick={() => this.delete()}
            >
              Confirm
            </button>
            <Link className="action" to={`/settings/companies`}>Cancel</Link>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/settings/companies/delete.js